import "./style.scss";
import { routes } from "routes/apiRoutes";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { formatUrlQuery } from "utils/helper";
import makeRequest from "services/makeRequest";
import { userStatuses } from "utils/constants";
import { formatDateTime } from "utils/helper";
import AddAccountModal from "./AddAccountModal";
import {
  Table,
  CustomHeader,
  TableFooter,
  Tag,
  Button,
  NotificationModal,
} from "components";

const PMAccounts = () => {
  const { user } = useSelector((state) => state.user);

  const initialFilterState = {
    agentId: user.agent_id,
    number: 1,
    size: 10,
  };

  const [filterState, setFilterState] = useState(initialFilterState);
  const [isFormModalOpen, setIsFormModalOpen] = useState(false);
  const [isNotificationModalVisible, setIsNotificationModalVisible] =
    useState(false);

  const [data, setData] = useState({
    accounts: null,
    loading: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFilterState({ ...filterState, [name]: value });
  };

  const fetchAccounts = async () => {
    setData({ ...data, loading: true });
    try {
      const { data } = await makeRequest(
        "get",
        routes.fetchPMAccounts(formatUrlQuery(filterState))
      );
      setData((prev) => ({
        ...prev,
        accounts: data.data,
        loading: false,
      }));
    } catch (err) {
      console.log(err);
      setData({ ...data, loading: false });
    }
  };

  const getStatusTag = (value) => {
    let val = userStatuses.find((status) => status.mapper === value);
    return val ? (
      <Tag
        text={val.text}
        backgroundColor={val.bgColor}
        textColor={val.color}
      />
    ) : (
      ""
    );
  };

  const columns = [
    {
      Header: "S/N",
      Cell: (row) => Number(row.row.id) + 1,
    },
    {
      Header: "Account Name",
      accessor: "accountName",
    },
    {
      Header: "Account Number",
      accessor: "accountNumber",
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ row }) =>{ 
       return getStatusTag(row.original?.status)}
    },
    {
      Header: "Created Date",
      accessor: "createdDate",
      Cell: ({ row }) => formatDateTime(row.original?.createdDate),
    },
  ];

  const { number, size } = filterState;

  useEffect(() => {
    fetchAccounts();
    //eslint-disable-next-line
  }, [number, size]);

  return (
    <div className="pt-4">
      <CustomHeader title="PM Accounts" titlePosition="center" />
      <div className="pm-accounts-container">
        <div className="d-flex justify-content-end">
          <Button
            label="Add Account"
            size="sm"
            className={"mb-4"}
            onClick={() => setIsFormModalOpen(true)}
          />
        </div>
        <Table
          columns={columns}
          data={data.accounts?.content}
          centerData
          loading={data.loading}
        />
        {data?.accounts?.content?.length ? (
          <TableFooter
            pageSize={filterState.size}
            handleChange={handleChange}
            availableDataLength={data?.accounts?.content?.length}
            totalDataLength={data.accounts.totalElements}
            handlePageClick={(pageNo) =>
              setFilterState({ ...filterState, number: pageNo })
            }
          />
        ) : (
          ""
        )}
      </div>
      <AddAccountModal
        isModalVisible={isFormModalOpen}
        setIsModalVisible={setIsFormModalOpen}
        setIsNotificationModalVisible={setIsNotificationModalVisible}
      />
      <NotificationModal
        showModal={isNotificationModalVisible}
        onClose={() => {
          setIsNotificationModalVisible(false);
          window.location.reload();
        }}
        bodyText={
          "You have successfully added a new PM Number, this awaits approval."
        }
        headerText="Request was submitted successfully!"
      />
    </div>
  );
};

export default PMAccounts;
